import { computed } from "vue";
import { useStore } from "vuex";

/**
 * Message Store Helpers
 * Provides simplified access to message getters and actions
 */
export function useMessageStore() {
  const store = useStore();
  
  // States
  const state = {
    roomMessages: computed(() => store.state.myPatients.message.roomMessages),
    sentMessages: computed(() => store.state.myPatients.message.sentMessages),
  }

  // Getters
  const getters = {
    getRoomMessages: (roomId) => store.getters["myPatients/message/getRoomMessages"](roomId),
    getSentMessage: (roomId, messageId) => store.getters["myPatients/message/getSentMessage"](roomId, messageId),
    getSentMessages: (roomId) => store.getters["myPatients/message/getSentMessages"](roomId),
    getRoomsWithMessages: computed(() => store.getters["myPatients/message/getRoomsWithMessages"]),
    getMessageCount: (roomId) => store.getters["myPatients/message/getMessageCount"](roomId),
  };

  // Actions
  const actions = {
    initializeRoom: (roomId, messages) => store.dispatch("myPatients/message/initializeRoom", { roomId, messages }),
    addMessage: (roomId, message) => store.dispatch("myPatients/message/addMessage", { roomId, message }),
    addMessages: (roomId, messages) => store.dispatch("myPatients/message/addMessages", { roomId, messages }),
    setRoomMessages: (roomId, messages) => store.dispatch("myPatients/message/setRoomMessages", { roomId, messages }),
    addSentMessage: (roomId, messageId, message) => store.dispatch("myPatients/message/addSentMessage", { roomId, messageId, message }),
    removeSentMessage: (roomId, messageId) => store.dispatch("myPatients/message/removeSentMessage", { roomId, messageId }),
    clearRoom: (roomId) => store.dispatch("myPatients/message/clearRoom", roomId),
    clearAllMessages: () => store.dispatch("myPatients/message/clearAllMessages"),
  };

  return {
    state,
    getters,
    actions,
  };
}
